<ng-scrollbar class="global-container" appearance="compact" #scrollable pointerEventsMethod="scrollbar">
  <div class="bread-crumb-container">
    <h2 class="margin-0">Pheme Report</h2>
  </div>
<div class="mt-3 mx-2">
  <div  *ngFor="let report of phemeReport">
       <mat-form-field class="" appearance="outline">
         <mat-label>Reports</mat-label>
         <mat-select (selectionChange)="filterCondition($event)" required>
           <mat-option  *ngFor="let pheme of report.AdhocReport" [value]="pheme.templateCode">
             {{pheme.templateName}}
           </mat-option>
         </mat-select>     
       </mat-form-field>
  </div>
  
  <div *ngFor="let type of filter;let i = index;">
    <div *ngIf="(type.column_type.includes('VARCHAR')||type.column_type=='NUMBER')&&Object.keys(type.dropdownvalue).length==0&&type.isValueQueryFlag=='false'">
      <mat-form-field class="" appearance="outline" *ngIf="type.column_name!='FACILITATIORID'&&type.column_name!='ATTENDEEID'&&type.column_name!='CREATEDBY'"> 
      <input  matInput required  [type]="type.column_type=='NUMBER'?'number':'text'" id="input_{{i}}" (blur)="check($event.target,type.column_type,i)" [placeholder]="type.column_name"/>
      </mat-form-field>

    <app-dropdown (selectedValue)="check($event,type.column_type,i)" [index]="i" [users]="users" [placeHolder]="type.column_name" *ngIf="type.column_name=='FACILITATIORID'||type.column_name=='ATTENDEEID'||type.column_name=='CREATEDBY'"></app-dropdown>

    </div>
    <div *ngIf="(type.column_type=='TIMESTAMP'||type.column_type=='DATE')&&Object.keys(type.dropdownvalue).length==0&&type.isValueQueryFlag=='false'">
      <mat-form-field class="" appearance="outline">   
      <mat-label>{{type.column_name}}</mat-label>
          <input required matInput #input [matDatepicker]="picker" (dateChange)="check($event.targetElement,type.column_type,i)" (focus)="picker.open()" id="date_{{i}}"  type="text"/>
          <mat-datepicker (closed)="input.blur()" #picker></mat-datepicker>
          </mat-form-field>
  </div>
  <div *ngIf="Object.keys(type.dropdownvalue).length>0&&type.isValueQueryFlag=='false'">
    <mat-form-field class="" appearance="outline"> 
    <mat-label>Filters</mat-label>
      <mat-select (selectionChange)="check($event,'dropdown',i)" id="dropdown_{{i}}" required>
         <mat-option  *ngFor="let phemeKey of Object.keys(type.dropdownvalue)" [value]="phemeKey">
          {{type.dropdownvalue[phemeKey]}}
        </mat-option>
      </mat-select>  
      </mat-form-field>   
  </div>
  <div *ngIf="type.isValueQueryFlag=='true'">
    <h1 [contentEditable]="false">{{type.valueQueryName}}</h1>
  </div>
  </div>
  <div class="mb-3">
    <mat-radio-group required aria-label="Select an option" [(ngModel)]="documentType">
      <mat-radio-button  *ngIf="exportType.includes('xlsx')" value="xlsx" >xlsx</mat-radio-button>
      <mat-radio-button class="matButton" *ngIf="exportType.includes('pdf')" value="pdf">pdf</mat-radio-button>
      <mat-radio-button class="matButton" *ngIf="exportType.includes('csv')" value="csv">csv</mat-radio-button>
    </mat-radio-group>
   </div>
   <div *ngIf="phemeReport.length==0">
    <span>No Reports Found</span>
  </div>
  <div *ngIf="phemeReport.length>0">
    <button mat-button class="button-container mar-r-10px primary" (click)="export()">Download</button>
  </div>

</div>
</ng-scrollbar>


